<template>
  <div class="tab-content">
    <div class="map-container">
      <div class="map-controls">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Filter:</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select">
                  <select v-model="mapFilter">
                    <option value="all">All Cameras</option>
                    <option value="active">Active Only</option>
                    <option value="deleted">Deleted Only</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="map-stats">
          <span class="tag is-info"
            >{{ validCameras.length }} cameras with location</span
          >
          <span class="tag is-warning"
            >{{ camerasWithoutLocation }} without location</span
          >
        </div>
      </div>
      <l-map
        ref="map"
        :zoom="zoom"
        :center="center"
        style="height: 600px; z-index: 1"
      >
        <l-tile-layer
          :url="tileUrl"
          :attribution="attribution"
        ></l-tile-layer>
        <l-marker
          v-for="camera in filteredCameras"
          :key="camera.id"
          :lat-lng="[camera.location.latitude, camera.location.longitude]"
          @click="$emit('open-camera-modal', camera)"
        >
          <l-icon
            :icon-url="getCameraIcon(camera)"
            :icon-size="[32, 32]"
            :icon-anchor="[16, 32]"
          />
          <l-popup>
            <div class="camera-popup">
              <h5 class="title is-6">{{ camera.name }}</h5>
              <p><strong>Project:</strong> {{ camera.project?.name }}</p>
              <p>
                <strong>Company:</strong>
                {{ camera.project?.company?.name }}
              </p>
              <p>
                <strong>Status:</strong>
                <span
                  :class="`tag is-small ${
                    camera.is_deleted ? 'is-danger' : 'is-success'
                  }`"
                >
                  {{ camera.is_deleted ? "Deleted" : "Active" }}
                </span>
              </p>
              <button
                class="button is-small is-primary"
                @click="$emit('open-camera-modal', camera)"
              >
                <span class="icon is-small">
                  <i class="fas fa-edit"></i>
                </span>
                <span>Edit</span>
              </button>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "MapTab",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
  },
  props: {
    cameras: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      zoom: 2,
      center: [20, 0],
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>',
      mapFilter: "all",
    };
  },
  computed: {
    validCameras() {
      return this.cameras.filter(
        (c) =>
          c.location && c.location.latitude !== 0 && c.location.longitude !== 0
      );
    },
    camerasWithoutLocation() {
      return this.cameras.filter(
        (c) =>
          !c.location || c.location.latitude === 0 || c.location.longitude === 0
      ).length;
    },
    filteredCameras() {
      if (this.mapFilter === "active") {
        return this.validCameras.filter((c) => !c.is_deleted);
      } else if (this.mapFilter === "deleted") {
        return this.validCameras.filter((c) => c.is_deleted);
      }
      return this.validCameras;
    },
  },
  methods: {
    getCameraIcon(camera) {
      const color = camera.is_deleted ? "red" : "green";
      return `data:image/svg+xml;base64,${btoa(`
        <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="8" fill="${color}" stroke="white" stroke-width="2"/>
        </svg>
      `)}`;
    },
    invalidateSize() {
      if (this.$refs.map) {
        this.$nextTick(() => {
          this.$refs.map.mapObject.invalidateSize();
        });
      }
    },
  },
};
</script>

<style scoped>
.tab-content {
  padding: 1.5rem;
}

.map-container {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.map-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.map-stats {
  display: flex;
  gap: 0.5rem;
}

.camera-popup {
  min-width: 200px;
}

.camera-popup .title {
  margin-bottom: 0.5rem;
}

.camera-popup p {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.camera-popup button {
  margin-top: 0.5rem;
}
</style>
